var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 4.75V6.5H8.25006C7.83443 6.5 7.50005 6.83437 7.50005 7.25V8.75C7.50005 9.16563 7.83443 9.5 8.25006 9.5H10.0001V11.25C10.0001 11.6656 10.3345 12 10.7501 12H12.2501C12.6657 12 13.0001 11.6656 13.0001 11.25V9.5H14.7501C15.1658 9.5 15.5001 9.16563 15.5001 8.75V7.25C15.5001 6.83437 15.1658 6.5 14.7501 6.5H13.0001V4.75C13.0001 4.33437 12.6657 4 12.2501 4H10.7501C10.3345 4 10.0001 4.33437 10.0001 4.75ZM20.4908 16.2563C21.0471 15.8469 21.1658 15.0656 20.7564 14.5094C20.3471 13.9531 19.5658 13.8344 19.0096 14.2437L15.2689 17H11.5001C11.2251 17 11.0001 16.775 11.0001 16.5C11.0001 16.225 11.2251 16 11.5001 16H12.0001H14.0001C14.5533 16 15.0001 15.5531 15.0001 15C15.0001 14.4469 14.5533 14 14.0001 14H12.0001H11.5001H9.05319C8.14381 14 7.26255 14.3094 6.55316 14.875L5.15002 16H4.00001C3.44688 16 3 16.4469 3 17V19C3 19.5531 3.44688 20 4.00001 20H9.00007H14.0157C14.922 20 15.8064 19.7094 16.5376 19.1719L20.4939 16.2563H20.4908ZM9.02194 16H9.05007C9.04069 16 9.03132 16 9.02194 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco08);
export default __webpack_public_path__ + "static/media/Gnb_ico_08.c5c83b0861d2b0e3a29bd80238c3ac6d.svg";
export { ForwardRef as ReactComponent };